/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';

import { Wrapper } from '../components/wrapper';
import PreTitle from '../components/pretitle';
import SubTitle from '../components/subtitle';
import Paragraph from '../components/paragraph';
import Alert from '../components/alert';
import Visual from '../components/visual';

const getAlertNumber = (previousShownErrors) => {
  let num = Number(previousShownErrors);
  if (isNaN(num)) {
    num = 0;
  }

  return 1 + num;
}

const BannerLayout = ({
  section,
  subSection,
  previousShownErrors,
  alertText,
  subTitle,
  paragraph1,
  paragraph2,
  visual,
  visualProps = {},
  hideAlert = false,
}) => (
  <Wrapper>
    <PreTitle>{section}{subSection ? ` | ${subSection}` : ''}</PreTitle>
    {!hideAlert && <Alert><span>{getAlertNumber(previousShownErrors)}</span> {alertText}</Alert>}
    <SubTitle>{subTitle}</SubTitle>
    {paragraph1 && <Paragraph>
      {paragraph1}
    </Paragraph>}
    <Visual data={visual} {...visualProps} />
    {paragraph2 && <Paragraph>
      {paragraph2}
    </Paragraph>}
  </Wrapper>
);

export default BannerLayout;



// WEBPACK FOOTER //
// ./src/components/performance-feedback/layouts/banner.js